<template>
  <button
    class="radio-list-play-button-parts"
    :class="[
      `radio-list-play-button-parts--${screenOrientationType}`,
      { 'radio-list-play-button-parts--active': isPlaying },
    ]"
    @click="playRadioAudio()"
  >
    <span
      v-if="isPlaying"
      class="radio-list-play-button-parts__gauge"
      :style="`width: ${gaugeWidth}%`"
    />
    <svg
      v-if="isPlaying"
      class="radio-list-play-button-parts__icon"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6.5 0H8V5H6.5V0Z" fill="#2B2B2B" />
      <path d="M9.5 4H12V5H9.5V4Z" fill="#2B2B2B" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6 6C5.44772 6 5 6.44772 5 7V17C5 17.5523 5.44772 18 6 18H11.4293C10.5452 17.0981 10 15.8627 10 14.5C10 12.4497 11.2341 10.6876 13 9.91604V7C13 6.44772 12.5523 6 12 6H6ZM11.5 7.5H6.5V8.5H11.5V7.5ZM6.5 9.5H11.5V10.5H6.5V9.5ZM7 13.5C7.27614 13.5 7.5 13.2761 7.5 13C7.5 12.7239 7.27614 12.5 7 12.5C6.72386 12.5 6.5 12.7239 6.5 13C6.5 13.2761 6.72386 13.5 7 13.5ZM9.5 13C9.5 13.2761 9.27614 13.5 9 13.5C8.72386 13.5 8.5 13.2761 8.5 13C8.5 12.7239 8.72386 12.5 9 12.5C9.27614 12.5 9.5 12.7239 9.5 13ZM7.5 15C7.5 15.2761 7.27614 15.5 7 15.5C6.72386 15.5 6.5 15.2761 6.5 15C6.5 14.7239 6.72386 14.5 7 14.5C7.27614 14.5 7.5 14.7239 7.5 15ZM9 15.5C9.27614 15.5 9.5 15.2761 9.5 15C9.5 14.7239 9.27614 14.5 9 14.5C8.72386 14.5 8.5 14.7239 8.5 15C8.5 15.2761 8.72386 15.5 9 15.5Z"
        fill="black"
      />
      <rect x="13" y="12" width="5" height="5" fill="#2B2B2B" />
    </svg>

    <svg
      v-else
      class="radio-list-play-button-parts__icon"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6.5 0H8V5H6.5V0Z" fill="white" />
      <path d="M9.5 4H12V5H9.5V4Z" fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6 6C5.44772 6 5 6.44772 5 7V17C5 17.5523 5.44772 18 6 18H11.4293C10.5452 17.0981 10 15.8627 10 14.5C10 12.4497 11.2341 10.6876 13 9.91604V7C13 6.44772 12.5523 6 12 6H6ZM11.5 7.5H6.5V8.5H11.5V7.5ZM6.5 9.5H11.5V10.5H6.5V9.5ZM7 13.5C7.27614 13.5 7.5 13.2761 7.5 13C7.5 12.7239 7.27614 12.5 7 12.5C6.72386 12.5 6.5 12.7239 6.5 13C6.5 13.2761 6.72386 13.5 7 13.5ZM9.5 13C9.5 13.2761 9.27614 13.5 9 13.5C8.72386 13.5 8.5 13.2761 8.5 13C8.5 12.7239 8.72386 12.5 9 12.5C9.27614 12.5 9.5 12.7239 9.5 13ZM7.5 15C7.5 15.2761 7.27614 15.5 7 15.5C6.72386 15.5 6.5 15.2761 6.5 15C6.5 14.7239 6.72386 14.5 7 14.5C7.27614 14.5 7.5 14.7239 7.5 15ZM9 15.5C9.27614 15.5 9.5 15.2761 9.5 15C9.5 14.7239 9.27614 14.5 9 14.5C8.72386 14.5 8.5 14.7239 8.5 15C8.5 15.2761 8.72386 15.5 9 15.5Z"
        fill="white"
      />
      <path
        d="M12.5 11.5L17.2596 14.2764C17.5904 14.4694 17.5904 14.9473 17.2596 15.1402L12.5 17.9167V11.5Z"
        fill="white"
      />
    </svg>

    <span class="radio-list-play-button-parts__time"
      >{{ Math.ceil(playerRadioData.duration) }}s</span
    >
  </button>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from '@vue/composition-api'
import RadioDataDocument from '@/store/stores/collectionModule/documents/Radio/RadioDataDocument'

/**
 * レース動画再生画面 選手選手用 無線アイテム 再生ボタンのコンポーネント
 */
export default defineComponent({
  name: 'RadioListPlayButtonParts',
  components: {},
  props: {
    /**
     * 画面向き
     */
    screenOrientationType: {
      type: String,
      default: 'portrait-primary',
    },
    /**
     * 選手無線データ
     */
    radioData: {
      type: Object as PropType<RadioDataDocument>,
      require: true,
    },
  },
  setup(props) {
    const playerRadioData = computed(() => props.radioData)
    const isPlaying = computed(() => props.radioData?.state.isPlaying.value)
    const currentTime = computed(() => props.radioData?.state.currentTime.value)

    /**
     * 無線交信データ再生のプログレス値
     */
    const gaugeWidth = computed(() => {
      const duration = playerRadioData.value ? playerRadioData.value.duration - 0.2 : 0
      const currentTimeValue = currentTime.value ?? 0
      return playerRadioData.value?.duration ? (currentTimeValue / duration) * 100 : 0
    })
    return {
      gaugeWidth,
      playerRadioData,
      isPlaying,
    }
  },
  methods: {
    /**
     * 無線の再生が実施された際に呼び出される。
     */
    playRadioAudio(): void {
      this.$emit('playRadio', this.radioData, false)
    },
  },
})
</script>

<style lang="scss" scoped>
.radio-list-play-button-parts {
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  width: 94px;
  height: 36px;
  padding: 8px 8px 8px 6px;
  border-radius: 4px;
  background-color: $gray75;
  color: #fff;
  overflow: hidden;
  z-index: 1;

  &__time {
    position: relative;
    z-index: 2;
    display: inline-block;
    width: 58px;
    text-align: center;
    font-weight: 600;
    font-size: 14px;
    line-height: 1.43;
  }

  &__icon {
    position: relative;
    z-index: 2;
    width: 18px;
  }

  &__gauge {
    position: absolute;
    z-index: 1;
    top: -1px;
    left: -1px;
    bottom: -1px;
    background-color: $green-light;

    // todo: ゲージの変化速度をここで調整(実装時にトランジションなしでも違和感がなければ削除)
    transition: width linear 0.3s;
  }

  &--active {
    background-color: #e5e5e5;

    .radio-list-play-button-parts {
      padding: 8px 4px 8px 2px;

      &__time {
        color: $black20;
      }

      &__gauge {
        display: block;
      }
    }
  }

  &--landscape-primary,
  &--landscape-secondary {
    width: 64px;
    padding: 8px 4px 8px 2px;

    .radio-list-play-button-parts {
      &__time {
        width: 43px;
        font-size: 13px;
        line-height: 1.54;
      }
    }
  }
}
</style>

<style lang="scss">
.radio-list-section {
  .radio-list-play-button-parts {
    width: 96px;
    height: 48px;

    @media screen and (max-width: 374px) {
      width: 66px;
      height: 46px;
    }

    &--landscape-primary,
    &--landscape-secondary {
      width: 66px;
      height: 46px;
    }
  }
}
</style>
